module.exports = __webpack_public_path__ + "img/born-of-ocean-swell-2.5fe3c949.webp";